import { fn } from "storybook/test"

import imageSelector from "./imageSelector"

const screenshotSelector = {
  images: imageSelector.images!,
  modal: {
    isOpen: false,
    onClose: fn()
  },
  onAddImage: fn(),
  onConfirm: fn(),
  onSelectClick: fn()
}

export default screenshotSelector
